<template>
  <div class="wrapper">
    <Loader :is-visible="loading" />

    <div class="animated fadeIn">
      <DynamicContentFilters
        :write-permission="writePermission"
        @apply="applyFilters"
        @add="modal.show = true"
      />

      <div class="card">
        <div class="card-header d-flex align-items-center">
          <i class="fa fa-graduation-cap"></i> Tutoriels
          <span v-if="total" class="ml-05">({{ total }})</span>
        </div>

        <div class="card-block">
          <div v-if="tutorials.length > 0">
            <DynamicContentTable
              :data="tutorials"
              :type="type"
              :write-permission="writePermission"
              @edit="editItem"
              @delete="handleDelete"
            />

            <Paginate
              ref="paginate"
              v-if="pageCount"
              v-model="page"
              :page-count="pageCount"
              :click-handler="changePage"
              prev-text="Précédent"
              next-text="Suivant"
              container-class="pagination"
              class="mt-1"
            ></Paginate>
          </div>

          <p v-else class="text-center">Aucun tutoriel trouvé</p>
        </div>
      </div>
    </div>

    <ModalDynamicContent
      :show="modal.show"
      :dynamic-content="modal.dynamicContent"
      :type="type"
      :write-permission="writePermission"
      @created="itemCreated"
      @updated="itemUpdated"
      @close="closeModal"
    />
  </div>
</template>

<script>
import Paginate from "vuejs-paginate";
import Loader from "@/components/utils/Loader";

import DynamicContentTable from "@/components/content/DynamicContentTable";
import DynamicContentFilters from "@/components/content/DynamicContentFilters";
import ModalDynamicContent from "@/components/modal/ModalDynamicContent";

export default {
  components: {
    DynamicContentFilters,
    Loader,
    ModalDynamicContent,
    DynamicContentTable,
    Paginate,
  },

  data() {
    return {
      loading: false,
      filters: {
        begin: null,
        end: null,
        name: "",
        publishedStatus: null,
      },
      type: "TUTO_COACH_APP",
      writePermission: "DYNAMIC_CONTENT_COACH_APP_TUTORIALS_WRITE",
      tutorials: [],
      total: 0,
      page: 1,
      offset: 0,
      limit: 15,
      count: true,
      modal: {
        show: false,
        dynamicContent: null,
      },
    };
  },

  computed: {
    pageCount() {
      return Math.ceil(this.total / this.limit);
    },
  },

  watch: {
    page() {
      if (this.page - 1 !== this.$refs.paginate.selected) {
        this.$refs.paginate.selected = this.page - 1;
      }
    },
  },

  created() {
    this.fetchTutorials();
  },

  methods: {
    async fetchTutorials() {
      try {
        this.loading = true;

        const { data } = await this.$api.get("/dynamic-contents", {
          params: {
            filters: { ...this.filters, type: this.type },
            offset: this.offset,
            limit: this.limit,
            currentTotal: this.total,
            count: this.count,
          },
        });

        this.tutorials = data.data;
        this.total = data.total;
        this.count = false;
      } catch (e) {
        this.tutorials = [];
      } finally {
        this.loading = false;
      }
    },

    applyFilters(filters) {
      this.filters = { ...this.filters, ...filters };
      this.count = true;

      this.changePage(1);
    },

    changePage(page) {
      this.page = page;
      this.offset = page * this.limit - this.limit;

      this.fetchTutorials();
    },

    itemCreated(item) {
      this.tutorials.unshift(item);
      this.total++;
    },

    itemUpdated(item) {
      this.tutorials = this.tutorials.map((tutorial) => {
        if (tutorial.id === item.id) {
          return { ...tutorial, ...item };
        }

        return tutorial;
      });
    },

    editItem(item) {
      this.modal.dynamicContent = { ...item };
      this.modal.show = true;
    },

    closeModal() {
      this.modal.show = false;
      this.modal.dynamicContent = null;
    },

    handleDelete(item) {
      if (!item || !item.id) {
        return;
      }

      this.$confirm({
        message: `Êtes-vous sûr.e de vouloir supprimer le tutoriel "${item.name}" ?`,
        onConfirm: () => this.deleteItem(item.id),
      });
    },

    async deleteItem(itemId) {
      try {
        this.loading = true;

        await this.$api.delete(`/dynamic-contents/${itemId}`);

        this.tutorials = this.tutorials.filter(({ id }) => id !== itemId);
        this.total--;

        this.$successToast("Tutoriel supprimé");
      } catch (e) {
        this.$errorToast("Impossible de supprimer ce tutoriel");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
